<template>
  <div class="modal fade" :id="dynamicId + 'cfsImageModal'" tabindex="-1" aria-labelledby="warning" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <img :id="dynamicId + 'cfsImageDisplay'" :alt="file.name" />
      </div>
    </div>
  </div>
  <div>
    <div class="d-md-flex" dir="ltr">
      <div>
        <fa-icon class="pointer ps-2 pe-2 text-hover-info" icon="fas fa-paperclip" size="2x" title="افزودن پیوست" @click="clickInput" />
        <label :for="dynamicId + 'cfsInputFile'">
          <input class="form-control d-none" type="file" :id="dynamicId + 'cfsInputFile'" @change="filesSelected" multiple />
        </label>
      </div>
      <div>
        <div v-for="(file, index) in files">
          <div class="d-flex text-truncate chat-attachment width-800-8 mb-0 mt-1 me-1">
            <fa-icon icon="fas fa-trash" class="text-danger pointer" style="margin: 0.25rem 0.4rem;"
              @click="removeFile(index)" />
            <div class="d-flex" :class="file?.type?.startsWith('image/') ? 'pointer' : ''" style="margin-top: 0.08rem;" :title="file.name" @click="openFile(file)">
              {{ file.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['maxFileCount', 'maxFileSize', 'dynamicId', 'validExtensions'],
  emits: ['filesUpdate'],
  data() {
    return {
      files: [],
      file: {},
      imageSrc: '',
    }
  },
  watch: {
    files(files) {
      this.$emit('filesUpdate', files);
    },
  },
  methods: {
    clickInput() {
      let input = document.getElementById(this.dynamicId + 'cfsInputFile');
      input.click();
    },
    filesSelected() {
      let newFiles = document.getElementById(this.dynamicId + 'cfsInputFile').files;
        if (newFiles.length == 0) { return; }
        
        newFiles = [...newFiles];

        for(let file of newFiles) {
          let fileNameArray = file.name.split('.').map(String);

          if (this.validExtensions?.length > 0 & !this.validExtensions.includes(fileNameArray[fileNameArray.length - 1])) {
            this.$toast.error('پسوند حداقل یکی از فایل‌ها مجاز نیست');
            return;
          }

          if (this.maxFileSize != null & file.size > this.maxFileSize) {
            this.$toast.error('حجم حداقل یکی از فایل‌ها بیش از سقف مجاز است');
            return;
          }
        }

        let filesArray = [...this.files, ...newFiles];
        if (filesArray.length > this.maxFileCount) {
          this.$toast.error(`حداکثر می‌توانید ${this.maxFileCount} فایل انتخاب کنید`);

          return;
        }

        let dataTransfer = new DataTransfer();
        filesArray.forEach(x => dataTransfer.items.add(x));

        this.files = dataTransfer.files;
    },
    removeFile(index) {
      let filesArray = [...this.files];
      filesArray.splice(index, 1);

      let dataTransfer = new DataTransfer();
      filesArray.forEach(x => dataTransfer.items.add(x));

      this.files = dataTransfer.files;
    },
    openFile(file) {
      if (file?.type?.startsWith('image/')) {
        let fileReader = new FileReader();
        let dynamicId = this.dynamicId

        fileReader.onload = function (e) {
          document.getElementById(dynamicId +'cfsImageDisplay').src = e.target.result;
        }

        fileReader.readAsDataURL(file);

        this.file = file;

        var imageModal = new bootstrap.Modal(document.getElementById(this.dynamicId + 'cfsImageModal'));
        imageModal.show();
      }
    },
  },
}
</script>